import React, {
  FunctionComponent,
  PropsWithChildren,
  ReactElement,
} from 'react';

import { ThemeProvider } from '@mui/material';

import Box from '../ui/Box/Box';
import Typography from '../ui/Typography/Typography';
import { filterTheme } from './theme/filter.theme';

const Filters: FunctionComponent<{ title?: string }> = (
  props: PropsWithChildren<{ title?: string }>
): ReactElement => {
  const { title = 'FILTER', children } = props;

  return (
    <ThemeProvider theme={filterTheme}>
      <Box
        sx={{
          mb: '36px',
          px: '24px',
          display: 'flex',
          flexWrap: 'wrap',
          backgroundColor: theme => theme.palette.appGrey.whiteSmoke,
          borderTop: 'solid 1px',
          gap: '8px',
          borderColor: theme => theme.palette.appGrey.greyPrimary,
        }}
      >
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 300,
            mt: '24px',
            mb: '24px',
            letterSpacing: '1.5px',
            position: 'absolute',
          }}
        >
          {title}
        </Typography>
        {children}
      </Box>
    </ThemeProvider>
  );
};

export default Filters;
